@if (submitted) {
  <div class="rc-loader__full-page">
    <app-loader></app-loader>
  </div>
}

<form
  [formGroup]="setPasswordForm"
  (submit)="onSubmit()"
  class="rc-content-v-middle set-password-form-container"
>
  <!-- Password -->
  <div class="input-wrapper">
    <div
      [class.mobile-auto-height]="showPopover"
      class="rc-dialog-form__input set-password-form-container__input"
    >
      <rc-field
        name="password"
        [error]="
          passwordControl?.touched &&
          !showPopover &&
          (passwordControl?.invalid ||
            passwordControl?.value === passwordError) &&
          ('registerApp_setPasswordError' | translate)
        "
        [placeholder]="'setPassword_fieldPwd' | translate"
        [type]="showPassword ? 'text' : 'password'"
        (blur)="popoverClose()"
        (focus)="popoverOpen()"
        appClickableLabel
        formControlName="password"
      >
        <div class="toggle-password-placeholder" suffix></div>
      </rc-field>

      <button
        (click)="showPassword = !showPassword"
        class="password-eye"
        type="button"
      >
        @if (!showPassword) {
          <svg
            height="32"
            viewBox="4 0 24 32"
            width="24"
            x="240"
            xmlns="http://www.w3.org/2000/svg"
            y="96"
          >
            <g data-name="View/Show" fill="#767676">
              <path
                d="M16 21c-4.16 0-7.63-4.19-7.77-4.37a1 1 0 0 1 0-1.26C8.37 15.19 11.84 11 16 11s7.63 4.19 7.77 4.37a1 1 0 0 1 0 1.26C23.63 16.81 20.16 21 16 21zm-5.65-5c1 1 3.28 3 5.65 3s4.47-1.8 5.65-3c-1-1-3.28-3-5.65-3-2.22 0-4.47 1.8-5.65 3z"
              />
              <circle cx="16" cy="16" r="2" />
            </g>
          </svg>
        }
        @if (showPassword) {
          <svg
            height="32"
            viewBox="4 0 24 32"
            width="24"
            x="144"
            xmlns="http://www.w3.org/2000/svg"
            y="128"
          >
            <g data-name="View/Hide" fill="#767676">
              <path
                d="M23.77 15.37a15.35 15.35 0 0 0-3.45-3l1.45-1.74a1 1 0 0 0-1.54-1.28l-1.76 2.11A7.32 7.32 0 0 0 16 11c-4.16 0-7.63 4.19-7.77 4.37a1 1 0 0 0 0 1.26 15.35 15.35 0 0 0 3.45 3l-1.45 1.74a1 1 0 0 0 .13 1.41A1 1 0 0 0 11 23a1 1 0 0 0 .77-.36l1.76-2.11A7.32 7.32 0 0 0 16 21c4.16 0 7.63-4.19 7.77-4.37a1 1 0 0 0 0-1.26zM10.35 16c1.18-1.2 3.43-3 5.65-3a5 5 0 0 1 1.08.14L13 18.06A13.37 13.37 0 0 1 10.35 16zM16 19a5 5 0 0 1-1.08-.14L19 13.94A13.37 13.37 0 0 1 21.65 16c-1.18 1.2-3.43 3-5.65 3z"
              />
              <circle cx="16" cy="16" r="2" />
            </g>
          </svg>
        }
      </button>
    </div>
    @if (showPopover) {
      <div
        class="rc-input--error-message set-password-form-container__password-errors popover"
      >
        <div class="set-password-form-container__password-rule" translate>
          SetPassword_rules0
        </div>
        <div
          [class.success__color]="
            !(
              passwordControl?.hasError(validationMessages.password[1].type) ||
              passwordControl?.hasError(validationMessages.password[0].type)
            )
          "
          class="set-password-form-container__password-rule"
        >
          {{ validationMessages.password[1].message }}
        </div>
        <div
          [class.success__color]="
            !(
              passwordControl?.hasError(validationMessages.password[2].type) ||
              passwordControl?.hasError(validationMessages.password[0].type)
            )
          "
          class="set-password-form-container__password-rule"
        >
          {{ validationMessages.password[2].message }}
        </div>
        <div
          [class.success__color]="
            !(
              passwordControl?.hasError(validationMessages.password[3].type) ||
              passwordControl?.hasError(validationMessages.password[0].type)
            )
          "
          class="set-password-form-container__password-rule"
        >
          {{ validationMessages.password[3].message }}
        </div>
        <div
          [class.success__color]="
            !(
              passwordControl?.hasError(validationMessages.password[4].type) ||
              passwordControl?.hasError(validationMessages.password[0].type)
            )
          "
          class="set-password-form-container__password-rule"
        >
          {{ validationMessages.password[4].message }}
        </div>
        <div
          [class.success__color]="
            !(
              passwordControl?.hasError(validationMessages.password[5].type) ||
              passwordControl?.hasError(validationMessages.password[0].type)
            )
          "
          class="set-password-form-container__password-rule"
        >
          {{ validationMessages.password[5].message }}
        </div>
        <div class="popover__arrow--scale">
          <div class="popover__arrow"></div>
        </div>
      </div>
    }
  </div>

  <!-- Password Confirm -->
  <div
    class="rc-dialog-form__input set-password-form-container__input2 input-wrapper"
  >
    <rc-field
      name="passwordConfirm"
      [error]="
        passwordConfirmControl?.touched &&
        setPasswordForm.hasError(validationMessages.passwordConfirm[1].type) &&
        validationMessages.passwordConfirm[1].message
      "
      [placeholder]="'setPassword_fieldConfirmPwd' | translate"
      [type]="showPasswordConfirm ? 'text' : 'password'"
      formControlName="passwordConfirm"
    >
      <div class="toggle-password-placeholder" suffix></div>
    </rc-field>
    <button
      (click)="showPasswordConfirm = !showPasswordConfirm"
      class="password-eye"
      type="button"
    >
      @if (!showPasswordConfirm) {
        <svg
          height="32"
          viewBox="4 0 24 32"
          width="24"
          x="240"
          xmlns="http://www.w3.org/2000/svg"
          y="96"
        >
          <g data-name="View/Show" fill="#767676">
            <path
              d="M16 21c-4.16 0-7.63-4.19-7.77-4.37a1 1 0 0 1 0-1.26C8.37 15.19 11.84 11 16 11s7.63 4.19 7.77 4.37a1 1 0 0 1 0 1.26C23.63 16.81 20.16 21 16 21zm-5.65-5c1 1 3.28 3 5.65 3s4.47-1.8 5.65-3c-1-1-3.28-3-5.65-3-2.22 0-4.47 1.8-5.65 3z"
            />
            <circle cx="16" cy="16" r="2" />
          </g>
        </svg>
      }
      @if (showPasswordConfirm) {
        <svg
          height="32"
          viewBox="4 0 24 32"
          width="24"
          x="144"
          xmlns="http://www.w3.org/2000/svg"
          y="128"
        >
          <g data-name="View/Hide" fill="#767676">
            <path
              d="M23.77 15.37a15.35 15.35 0 0 0-3.45-3l1.45-1.74a1 1 0 0 0-1.54-1.28l-1.76 2.11A7.32 7.32 0 0 0 16 11c-4.16 0-7.63 4.19-7.77 4.37a1 1 0 0 0 0 1.26 15.35 15.35 0 0 0 3.45 3l-1.45 1.74a1 1 0 0 0 .13 1.41A1 1 0 0 0 11 23a1 1 0 0 0 .77-.36l1.76-2.11A7.32 7.32 0 0 0 16 21c4.16 0 7.63-4.19 7.77-4.37a1 1 0 0 0 0-1.26zM10.35 16c1.18-1.2 3.43-3 5.65-3a5 5 0 0 1 1.08.14L13 18.06A13.37 13.37 0 0 1 10.35 16zM16 19a5 5 0 0 1-1.08-.14L19 13.94A13.37 13.37 0 0 1 21.65 16c-1.18 1.2-3.43 3-5.65 3z"
            />
            <circle cx="16" cy="16" r="2" />
          </g>
        </svg>
      }
    </button>
  </div>

  <div class="rc-one-column set-password-form-container__button">
    <rc-button
      [disabled]="!setPasswordForm.valid"
      [name]="'setPassword_fieldButton' | translate"
      type="submit"
    >
    </rc-button>
  </div>
</form>
